export enum LocationType {
  WAREHOUSE = 'warehouse',
  LOCATION = 'location',
}

export enum DefaultPickingLocation {
  RECEIVING = 'Receiving',
  SHIPPING = 'Shipping',
}
